import { Card, Col, Row } from "antd";
import React from "react";

import {
	IoLinkOutline,
	IoLogoFacebook,
	IoLogoGoogle,
	IoLogoInstagram,
	IoLogoLinkedin,
	IoLogoTwitter,
	IoLogoWhatsapp,
	IoLogoYoutube,
} from "react-icons/io5";

import { getToken, POST_API, POST_CATCH } from "../../services/api";

class WebPerfilContato extends React.Component {
	state = {
		_params: window.location.href.split("/"),
		profile: null,
	};

	componentDidMount = () => {
		this.onView();
	};

	onView = async () => {
		await POST_API("/credential/search.php", {
			token: getToken(),
			filter: JSON.stringify({ ID: this.state._params[4] }),
			type: "view",
		})
			.then((rs) => rs.json())
			.then((res) => {
				this.setState({ profile: res.data, _screen: false });
			})
			.catch(() => POST_CATCH());
	};

	render = () => {
		return (
			<Row className="perfil-content-row" gutter={[16, 16]}>
				<Col md={10} xs={24}>
					<Row gutter={[16, 16]}>
						<Col span={24}>
							<Card title="Contatos">
								{this.state.profile?.EMAIL ? (
									<a
										className="btn-link-contato"
										href={`mailto:${this.state.profile?.EMAIL}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoGoogle
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.EMAIL}
									</a>
								) : null}
								{this.state.profile?.WHATSAPP ? (
									<a
										className="btn-link-contato"
										href={`https://web.whatsapp.com/send?phone=${this.state.profile?.WHATSAPP}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoWhatsapp
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.WHATSAPP}
									</a>
								) : null}
								{this.state.profile?.FACEBOOK ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.FACEBOOK}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoFacebook
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.FACEBOOK}
									</a>
								) : null}
								{this.state.profile?.INSTAGRAM ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.INSTAGRAM}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoInstagram
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.INSTAGRAM}
									</a>
								) : null}
								{this.state.profile?.TWITTER ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.TWITTER}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoTwitter
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.TWITTER}
									</a>
								) : null}
								{this.state.profile?.LINKEDIN ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.LINKEDIN}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoLinkedin
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.LINKEDIN}
									</a>
								) : null}
								{this.state.profile?.YOUTUBE ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.YOUTUBE}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoYoutube
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.YOUTUBE}
									</a>
								) : null}
								{this.state.profile?.SITE ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.SITE}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLinkOutline
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.SITE}
									</a>
								) : null}
							</Card>
						</Col>
					</Row>
				</Col>
				<Col md={14} xs={24}>
					<iframe
						allowfullscreen
						frameborder="0"
						height={400}
						src={`https://maps.google.com/maps?q=${this.state.profile?.STREET} ${this.state.profile?.NUMBER} ${this.state.profile?.DISTRICT} ${this.state.profile?.CITY}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
						title="mapa"
						width={"100%"}
					/>
				</Col>
			</Row>
		);
	};
}

export default WebPerfilContato;
